import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { returnLoginStatus } from "../hooks/authFunc";

const MyPageRoutes = () => {
  const isLogin = returnLoginStatus();

  return isLogin ? <Outlet /> : <Navigate to="/required/login" />;
};

export default MyPageRoutes;
